import React from 'react';
import { Helmet } from 'react-helmet';
import { useTranslation } from 'react-i18next';
import ApiDocumentation from '../../component/CorderApiDocumentation/ApiDocumentation';

const CorderApiDocumentationContainer = () => {
	const { t } = useTranslation();

	return (
		<div className='api-docs-page'>
			<Helmet>
				<title>{t('corder_api')}</title>
				<meta name='description' content={t('corder_api_description')} />
			</Helmet>
			<ApiDocumentation />
		</div>
	);
};

export default CorderApiDocumentationContainer;
